import React from 'react';
import PropTypes from 'prop-types';

function Dialog({ type, align, content, icon }) {
  const alignment = align ? align : 'column';
  const iconPosition = alignment === 'column' ? 'd-flex justify-center' : '';

  return (
    <div className={`dialog dialog--${type}`}>
      <div className={`dialog--${alignment}`}>
        <div className={iconPosition}>{icon}</div>
        <div dangerouslySetInnerHTML={{ __html: content }}></div>
      </div>
    </div>
  );
}

export const DialogAlignments = {
  row: 'row',
  column: 'column',
};

export const DialogTypes = {
  info: 'info',
  error: 'error',
  feature: 'feature'
};


Dialog.defaultProps = {
  type: 'info',
  align: 'column',
};

Dialog.propTypes = {
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
  ]).isRequired,
};

export default Dialog;
